var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
import React from 'react';
import styled, { css } from 'styled-components';
import { classNames } from '@shapeable/utils';
var cls = classNames('horizontal-scroll');
import { breakpoints } from '@shapeable/theme';
export var HorizontalScrollDefaultProps = {
  fadeColor: '#FFFFFF',
  fadeWidth: '10px'
};
// -------- Styles -------->
var ContainerStyles = breakpoints({
  base: css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    position: relative;\n    width: 100%;\n    overflow-x: auto;\n    overflow-y: hidden;\n    justify-content: center;\n    align-items: center;\n    padding: 0;\n    -webkit-overflow-scrolling: touch;\n    &::-webkit-scrollbar {\n      display: none;\n    }\n  "], ["\n    position: relative;\n    width: 100%;\n    overflow-x: auto;\n    overflow-y: hidden;\n    justify-content: center;\n    align-items: center;\n    padding: 0;\n    -webkit-overflow-scrolling: touch;\n    &::-webkit-scrollbar {\n      display: none;\n    }\n  "])))
});
var FadeStyles = breakpoints({
  base: css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    position: absolute;\n    height: 100%;\n    right: 0;\n    top: 0;\n\n    ", "\n  "], ["\n    position: absolute;\n    height: 100%;\n    right: 0;\n    top: 0;\n\n    ", "\n  "])), function (_a) {
    var _color = _a._color,
      _width = _a._width;
    return css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n      width: ", ";\n      background: linear-gradient(", "00 0%, ", "FF 100%);\n    "], ["\n      width: ", ";\n      background: linear-gradient(", "00 0%, ", "FF 100%);\n    "])), _width, _color, _color);
  })
});
// -------- Components -------->
var My = {
  Container: styled.div(templateObject_4 || (templateObject_4 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles),
  Fade: styled.span.attrs(cls.attr('fade'))(templateObject_5 || (templateObject_5 = __makeTemplateObject(["", ""], ["", ""])), FadeStyles)
};
export var HorizontalScroll = function (props) {
  var className = props.className,
    children = props.children,
    showFade = props.showFade,
    fadeColor = props.fadeColor,
    fadeWidth = props.fadeWidth;
  return React.createElement(My.Container, {
    className: cls.name(className)
  }, children, showFade && React.createElement(My.Fade, {
    _color: fadeColor,
    _width: fadeWidth
  }));
};
HorizontalScroll.defaultProps = HorizontalScrollDefaultProps;
HorizontalScroll.cls = cls;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5;